import { render } from "./FeedPage.vue?vue&type=template&id=4c68022e&scoped=true"
import script from "./FeedPage.vue?vue&type=script&lang=js"
export * from "./FeedPage.vue?vue&type=script&lang=js"

import "./FeedPage.vue?vue&type=style&index=0&id=4c68022e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c68022e"]])

export default __exports__